import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Address } from '../../../projects/shared-lib/src/lib/models/address';
import { stripAccents } from '../../../projects/shared-lib/src/lib/utils/string-utils';

export interface FilterPageInterface {
    startDate?: Date;
    endDate?: Date;
    address?: Address;
    search?: any;
    action?: any;
    time?: any;
    locationSelected?: any[];
    category?: any[];
    categorySelected?: any[];
}

@Injectable({
    providedIn: 'root'
})
export class FilterPageService {
    filter = new BehaviorSubject<FilterPageInterface>({});

    constructor() {
    }


    normalizeSearchTerm(term: string | null | undefined): string {
        if (!term) {
            return '';
        }
        return stripAccents(term.trim());
    }


    matchesSearch(text: string | null | undefined, searchTerm: string | null | undefined): boolean {
        if (!text || !searchTerm) {
            return false;
        }
        const normalizedText = this.normalizeSearchTerm(text).toLowerCase();
        const normalizedSearch = this.normalizeSearchTerm(searchTerm).toLowerCase();
        return normalizedText.includes(normalizedSearch);
    }
}
